// extracted by mini-css-extract-plugin
module.exports = {"error":"Error__error___2Xp2G colors__secondary___1GWSi colors__bg-error___2zPun","warning":"Error__warning___AnuNR"};